import { render, staticRenderFns } from "./OverdueInvoices.vue?vue&type=template&id=213f59a8&scoped=true"
import script from "./OverdueInvoices.vue?vue&type=script&lang=js"
export * from "./OverdueInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f59a8",
  null
  
)

export default component.exports